import React from "react";
import {
  useAcceptRejectAppointmentMutation,
  useGetAppointmentsQuery,
} from "src/api/appointmentsApiSlice";
import crossImage from "../../assets/images/icons/svg/cross.svg";
import tickImage from "../../assets/images/icons/svg/tick.svg";
import sampleFaceImage from "../../assets/images/icons/svg/sample-face.svg";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import styled from "@emotion/styled";
import dayjs from "dayjs";

const RequestedAppointments = styled.div`
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.25);
  padding: 20px;
`;

const AppointmentRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const UserImage = styled.img``;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
`;

const UserName = styled.div`
  color: #2e2e2e;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const Requests = (props) => {
  const { data, isLoading, isSuccess, isError, error } =
    useGetAppointmentsQuery({ appointmentStatus: "requested" });
  // useGetAppointmentsQuery({ isApproved: false });

  const [updateAppointment, { isLoading: isUpdating }] =
    useAcceptRejectAppointmentMutation();

  const handleAppointment = (appointment, isApproved) => {
    console.log(appointment);
    updateAppointment({
      id: appointment._id,
      patch: {
        appointmentStatus: isApproved ? "approved" : "rejected",
      },
    });
  };

  if (isLoading) return "loading...";

  if (isError) return "error occured: " + error.message;

  if (data) console.log("appointments data:", data);

  return (
    <RequestedAppointments>
      {data && data.length && data.length > 0 ? (
        data.map((row, i) => (
          <>
            <AppointmentRow>
              <UserImage src={sampleFaceImage} />
              <HorizontalGap size={"20px"} />
              <Details>
                <UserName>{row.userId.name}</UserName>
                <div>{row.orgOfferingId.name}</div>
                <div style={{ fontSize: "13px" }}>
                  {`${dayjs(row.startTime).format("YYYY-MM-DD")}`}{" "}
                  <span style={{ fontSize: "12px" }}>
                    {" "}
                    {`( ${dayjs(row.startTime).format("hh:mm A")} - ${dayjs(
                      row.endTime
                    ).format("hh:mm A")} )`}
                  </span>
                </div>
              </Details>
              <HorizontalGap size={"20px"} />
              <Actions>
                <img
                  src={tickImage}
                  onClick={() => handleAppointment(row, true)}
                />
                <HorizontalGap size={"5px"} />
                <img
                  src={crossImage}
                  onClick={() => handleAppointment(row, false)}
                />
              </Actions>
            </AppointmentRow>
            {i != data.length - 1 ? <VerticalGap size={"40px"} /> : null}
          </>
        ))
      ) : (
        <div>No requests</div>
      )}
    </RequestedAppointments>
  );
};

export { Requests };
